import { useMasterParams } from "@/api/master-param";
import { generateCustomSpec } from "@/utils/helper";

export default function useNotificationSpec() {
  const { data: modules } = useMasterParams({
    paramType: "NOTIF_MODULE",
    sort: "value",
    active: "true",
  });
  const moduleOptions = modules?.content?.map((item) => {
    return {
      label: item.value,
      key: item.value,
    };
  });

  const { data: types } = useMasterParams({
    paramType: "NOTIF_TYPE",
    sort: "value",
    active: "true",
  });
  const typeOptions = types?.content?.map((item) => {
    return {
      label: item.value,
      key: item.value,
    };
  });

  const spec = generateCustomSpec({
    path: "",
    canBulk: false,
    fields: [
      {
        label: "Message",
        name: "notification.message",
        sortable: true,
      },
      {
        label: "Module",
        name: "notification.module",
        sortable: true,
        select_options: {
          options: moduleOptions,
        },
      },
      {
        label: "Status",
        name: "notification.statusData",
        sortable: true,
      },
      {
        label: "Created Date",
        name: "createdDate",
        sortable: true,
      },
      {
        label: "Type",
        name: "notification.type",
        sortable: true,
        select_options: {
          options: typeOptions,
        },
      },
      {
        label: "Read",
        name: "isRead",
        sortable: false,
        filterable: false,
        searchable: false,
      },
    ],
  });

  return spec;
}
